angular.module 'zc.users', [
  'zc.core'
]




// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/users/index.js.coffee